import { useTheme } from "@mui/material";
import { alpha, type Theme } from "@mui/material/styles";

export type HardcopyBorders = {
  solid1: string;
  solid1Soft: string;
  solid5: string;
};

/**
 * Pure border tokens for receipt hardcopy (print) routes.
 * `solid5` uses `text.primary` so the page frame prints darker than thin field lines.
 */
export function getHardcopyBorders(theme: Theme): HardcopyBorders {
  const d = theme.palette.divider;
  const soft = alpha(theme.palette.text.primary, 0.14);
  return {
    solid1: `1px solid ${d}`,
    solid1Soft: `1px solid ${soft}`,
    solid5: `5px solid ${theme.palette.text.primary}`,
  };
}

/**
 * Inline `style={{ border… }}` helpers for receipt print routes (no `sx` on plain divs).
 */
export function useHardcopyBorders() {
  return getHardcopyBorders(useTheme());
}
